import { getActivityModule } from "../../../modules/cmoe/activityModuleRegistry";
import { saveActivitySnapshot } from "../../../repositories/cmoe/firestoreActivityRepository";
import { isCmoeActivityModuleEnabled } from "../../../config/cmoeFeatureFlags";

/**
 * Shared go-live activity attach (Command API + dual-write).
 * @param {Object} params
 * @param {string} params.matchId
 * @param {string} params.roomCode
 * @param {import('../../../domain/cmoe/match/matchTypes').MatchSummary} params.summary
 * @param {unknown} [params.scoringMatch]
 */
export async function persistActivityOnGoLive({ matchId, roomCode, summary, scoringMatch = null }) {
  if (!isCmoeActivityModuleEnabled()) return;
  const modRef = summary.activityModuleRef;
  const mod = modRef ? getActivityModule(modRef.moduleId, modRef.moduleVersion) : null;
  if (!mod) return;
  const snap = mod.createInitialState({ bindings: summary.bindings });
  if (scoringMatch) {
    snap.payload = { ...snap.payload, scoringMatch };
  }
  await saveActivitySnapshot(matchId, {
    roomCode,
    activityModuleRef: modRef,
    activityVersion: snap.activityVersion,
    eventSeq: snap.eventSeq,
    payloadSchemaVersion: snap.payloadSchemaVersion,
    payload: mod.serialize(snap),
  });
}
